import { convertKeyValueDataIntoList } from '../DetailPageDataUtils'

const KeyValueLayout = ({ layout, value }) => {
  let keyValueData = convertKeyValueDataIntoList(value)

  return (
    <div
      style={{
        padding: '16px 20px 32px 20px',
        background: layout.color ? `#${layout.color}` : '',
        //  background: '#ff0000',
      }}
    >
      <div
        style={{
          marginTop: '10px',
          marginBottom: '24px',
          textAlign: 'left',
          color: 'var(--gray100)',
          listStyle: 'none',
        }}
      >
        <p className="title2">{layout.display_name}</p>
      </div>
      <div
        style={{
          textAlign: 'left',
          color: 'var(--gray80)',
        }}
      >
        <p className="body2">{value.text}</p>
      </div>

      {keyValueData != undefined &&
        keyValueData.map((item) => {
          return (
            <>
              {item.value && (
                <div
                  style={{
                    display: 'flex',
                    marginBottom: '-1rem',
                    alignItems: 'center',
                  }}
                >
                  <p>
                    <span
                      className="body2"
                      style={{ color: 'var(--gray100)', lineHeight: '150%' }}
                    >
                      {item.key + ' :   '}
                    </span>
                    <span
                      className="body2"
                      style={{ color: 'var(--gray80)', lineHeight: '150%' }}
                    >
                      {item.key === 'Phone' && (
                        <a
                          href={'tel:' + item.value}
                          target="__blank"
                          style={{
                            textDecoration: 'none',
                            color: 'var(--primaryShades20)',
                          }}
                        >
                          {item.value}
                        </a>
                      )}
                      {item.key === 'Address' && item.value}
                      {item.key === 'Email' && (
                        <a
                          href={'mailto:' + item.value}
                          target="__blank"
                          style={{
                            textDecoration: 'none',
                            color: 'var(--primaryShades20)',
                          }}
                        >
                          {item.value}
                        </a>
                      )}
                      {item.key === 'Website' && (
                        <a
                          href={'https://' + item.value}
                          target="__blank"
                          style={{
                            textDecoration: 'none',
                            color: 'var(--primaryShades20)',
                          }}
                        >
                          {item.value}
                        </a>
                      )}
                    </span>
                  </p>
                </div>
              )}
            </>
          )
        })}
    </div>
  )
}
export default KeyValueLayout
